export const RadioGroupOrientation = {
  horizontal: 'horizontal',
  vertical: 'vertical',
} as const;

export type RadioGroupOrientation =
  (typeof RadioGroupOrientation)[keyof typeof RadioGroupOrientation];

export type RadioProps = {
  value: string;
  label?: string;
  disabled?: boolean;
};

export type RadioGroupProps = {
  id?: string;
  label?: string;
  error?: string;
  modelValue: string;
  disabled?: boolean;
  disabledReason?: string;
  required?: boolean;
  name?: string;
  orientation?: RadioGroupOrientation;
  withGap?: boolean;
};

export type RadioGroupEmits = {
  'update:modelValue': [value: string];
};
